import React from 'react';
import { Input, DropdownItem, DropdownMenu, DropdownToggle, Nav, NavItem, NavLink } from 'reactstrap';
import PropTypes from 'prop-types';

import { useHistory } from 'react-router-dom';

import { useSelector, useDispatch } from 'react-redux';

import { AppHeaderDropdown, AppNavbarBrand, AppSidebarToggler } from '@coreui/react';
import logo from '../../assets/img/brand/logo.svg';
import sygnet from '../../assets/img/brand/sygnet.svg';

const propTypes = {
  children: PropTypes.node
};

export default (props) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const auth = useSelector(state => state.authentication);

  const handleChannelChange = (evt) => {
    const channelId = evt.target.value;
    localStorage.setItem('channel', channelId);
    dispatch({ type: 'SET_CHANNEL', data: channelId });
  };

  const logOut = async () => {
    await localStorage.clear();
    window.location = '/signin';
  };

  return (
    <React.Fragment>
      <AppSidebarToggler className="d-lg-none" display="md" mobile />
      <AppNavbarBrand
        full={{ src: logo, width: 89, height: 25, alt: 'CoreUI Logo' }}
        minimized={{ src: sygnet, width: 30, height: 30, alt: 'CoreUI Logo' }}
      />
      <AppSidebarToggler className="d-md-down-none" display="xs" />

      <Nav className="d-md-down-none" navbar>
        <NavItem className="px-3">
          <NavLink href="/">Dashboard</NavLink>
        </NavItem>
      </Nav>
      <Nav className="ml-auto" navbar>
        <NavItem>
          <Input
            value={auth.channel.id}
            type="select"
            id="channel"
            onChange={handleChannelChange}
          >
            <option key={0} value={''}>{'Select Channel'}</option>
            {auth.whoami.channels.map((channel) => {
              return (<option key={channel.id} value={channel.id}>{channel.name}</option>);
            })}
          </Input>
        </NavItem>
        <AppHeaderDropdown>
          <DropdownToggle nav>
            <img src={'assets/img/avatars/6.jpg'} className="img-avatar" alt={props.user.first_name} />
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem onClick={() => history.push('/home/changePassword')}><i className="fa fa-wrench"></i> Change Password </DropdownItem>
            <DropdownItem onClick={logOut}><i className="fa fa-lock"></i> Logout</DropdownItem>
          </DropdownMenu>
        </AppHeaderDropdown>
      </Nav>
    </React.Fragment>

  )
}



// WEBPACK FOOTER //
// ./src/containers/DefaultLayout/DefaultHeader.jsx